'use client';

import { FC } from 'react';
import Image from 'next/image';
import FadeIn from '@/components/FadeIn/FadeIn';

// Left group badges
const LEFT_BADGES = [
  {
    src: '/images/G2/ConversationalMarketing_HighPerformer_HighPerformer.svg',
    alt: 'G2 High Performer',
    rotation: -8,
    zIndex: 1,
  },
  {
    src: '/images/G2/ConversationalMarketing_BestEstimatedROI_Roi.svg',
    alt: 'G2 Best Est. ROI',
    rotation: 0,
    zIndex: 2,
  },
  {
    src: '/images/G2/AIChatbots_EasiestToDoBusinessWith_EaseOfDoingBusinessWith.svg',
    alt: 'G2 Easiest To Do Business With',
    rotation: 8,
    zIndex: 1,
  },
];

// Right group badges
const RIGHT_BADGES = [
  {
    src: '/images/G2/ConversationalMarketing_BestSupport_QualityOfSupport.svg',
    alt: 'G2 Best Support',
    rotation: -8,
    zIndex: 1,
  },
  {
    src: '/images/G2/AIChatbots_EasiestSetup_EaseOfSetup.svg',
    alt: 'G2 Easiest Setup',
    rotation: 8,
    zIndex: 2,
  },
];

const BadgeGroup: FC<{
  badges: typeof LEFT_BADGES;
  className?: string;
}> = ({ badges, className }) => (
  <div className={`flex items-center justify-center ${className}`}>
    {badges.map((badge, index) => (
      <div
        key={index}
        className="relative transition-transform hover:scale-105"
        style={{
          transform: `rotate(${badge.rotation}deg)`,
          zIndex: badge.zIndex,
          marginLeft: index > 0 ? '-20px' : '0',
        }}
      >
        <Image
          src={badge.src}
          alt={badge.alt}
          width={140}
          height={160}
          className="w-28 h-32 md:w-32 md:h-36 lg:w-36 lg:h-40 object-contain drop-shadow-lg"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
          }}
        />
      </div>
    ))}
  </div>
);

const AwardsBadges: FC = () => {
  return (
    <section className="py-16 md:py-24 overflow-hidden">
      <div
        className="container-fluid px-4 md:px-7.5 mx-auto"
        style={{ maxWidth: 'clamp(1200px, 80vw, 1400px)' }}
      >
        <FadeIn variant="up" delay={0.1}>
          {/* Section Title */}
          <div className="text-center mb-12">
            <h2
              className="font-medium text-black"
              style={{ fontSize: 'clamp(1.5rem, 2.5vw, 2.5rem)' }}
            >
              Top performer in{' '}
              <span style={{ color: '#094FFE' }}>lead generation</span>{' '}
              categories
            </h2>
          </div>

          {/* Badge Groups */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 lg:gap-24">
            <BadgeGroup badges={LEFT_BADGES} />
            <BadgeGroup badges={RIGHT_BADGES} />
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default AwardsBadges;
